import React from 'react';
import PropTypes from 'prop-types';
import TransportMode from './TransportMode';
import RouteAutosuggest from './RouteAutosuggest';
import TrainTimetableInfo from '../../containers/TimeTables/components/TrainTimetableInfo';
import { SEARCH_MODE } from '../../services/TimetablesService';

const bem = 'tt-route-search';
export default class RouteSearchComponent extends React.Component {
  render() {
    const { searchMode } = this.props;
    const isTrainMode = searchMode === SEARCH_MODE.TRAIN;
    return (
      <div className={bem}>
        <div className={`${bem}__tranport-mode`}><TransportMode /></div>
        {isTrainMode ? (
          <TrainTimetableInfo />
        ) : (
          <div className={`${bem}__autosuggest`}><RouteAutosuggest storageKey="recentTimetables" /></div>
        )}
      </div>
    );
  }
}

RouteSearchComponent.propTypes = {
  searchMode: PropTypes.string.isRequired,
};
